import { objectOperations } from "@/commonJS/Actions/actionInterface";

export const performObjectOperations = (
  objectValue: any,
  operations: objectOperations[],
  globalState: any,
  fullGlobalState?: any,
  reduxState?: any,
  collectionStateOrPayload?: any
) => {
  let modifiedObj: any = {};
  for (const currentOperation of operations) {
    switch (currentOperation?.type) {
      case "filter":
        Object.entries(objectValue).forEach(([key, value]) => {
          if (value === true) {
            modifiedObj[key] = value;
          }
        });
        break;
      default:
        modifiedObj = objectValue;
        break;
    }
  }
  return modifiedObj;
};
